'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Translations = void 0;
var transport_1 = require("../../transport");
var Translations = /** @class */ (function () {
    function Translations() {
    }
    Translations.prototype.fetch = function (url) {
        return transport_1.transport.getHttpDriver().get(url);
    };
    return Translations;
}());
exports.Translations = Translations;
